import { render } from "./MobileAppsLinks.vue?vue&type=template&id=4228e9d5"
import script from "./MobileAppsLinks.vue?vue&type=script&lang=js"
export * from "./MobileAppsLinks.vue?vue&type=script&lang=js"

import "./MobileAppsLinks.vue?vue&type=style&index=0&id=4228e9d5&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__